import Stats from "./Stats";
import Table from "./Table";

function Notifications() {
  return (
    <div>
        <Stats />
        <Table />
    </div>
  );
}

export default Notifications;
